import { KeycloakHelperService } from "./keycloak.helper.service";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

interface LabelTypes {
  taxIdentifierLabel: string;
  mileageUnit: string;
}

const brazilianMasks: LabelTypes = {
  taxIdentifierLabel: "CNPJ",
  mileageUnit: "KM"
};

const argentinianMasks: LabelTypes = {
  taxIdentifierLabel: "CUIT",
  mileageUnit: "KM"
};

const americanMasks: LabelTypes = {
  taxIdentifierLabel: "TAX ID",
  mileageUnit: "Mileage"
};

const nederlandsMask: LabelTypes = {
  taxIdentifierLabel: "ID Number",
  mileageUnit: "KM"
};

export const defaultMileageUnit = brazilianMasks.mileageUnit;

@Injectable({
  providedIn: "root"
})
export class LabelService {
  labels: LabelTypes = nederlandsMask;

  constructor(
    private keycloakHelperService: KeycloakHelperService,
    private translateService: TranslateService
  ) {
    this.setLabels();
  }

  setLabels() {
    if (this.keycloakHelperService.isArgentinian()) {
      this.labels = argentinianMasks;
      return;
    }

    if (this.keycloakHelperService.isNorthAmerican()) {
      this.labels = americanMasks;
      return;
    }

    if (this.keycloakHelperService.isBrazilian()) {
      this.labels = brazilianMasks;
      return;
    }
  }

  getTaxIdentifierLabel() {
    return this.labels.taxIdentifierLabel;
  }

  getMileageUnit() {
    return this.labels.mileageUnit;
  }

  getTaxIdentifierRequiredText() {
    return this.translateService.instant("required-masculine", {
      label: this.labels.taxIdentifierLabel
    });
  }
}
